import { render, staticRenderFns } from "./doughnut-chart.vue?vue&type=template&id=0e8095f3"
import script from "./doughnut-chart.vue?vue&type=script&lang=js"
export * from "./doughnut-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports